export const PARTNER_STUDIO_ID = 'partner-studio-id' as const
